import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, Avatar, Skeleton } from '@mui/material';
import { getProfileData } from '../../../../redux/thunks/prescriptionThunks';
import { actions as prescriptionActions } from '../../../../redux/reducers/prescriptionReducer';
import {
    TotalTrigger,
    UniquePatients,
    TouchPoints,
    TotalRx,
    Touch,
    Check,
} from '../../../../assets/prescriber-profile';
import { CloseIcon } from '../../../../assets';
import { updateStringNPPA } from '../../../../utility';
import EngagementTypeTable from './engagementTypeTable';
import { handlePrescribersHeading } from '../../../../utility/companySpecificFunctions';

const formattedDate = (inputDate, timeZone = 'Asia/Kolkata') => {
    if (!inputDate) return '-';
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    const date = new Date(inputDate);
    const formattedDateString = date.toLocaleDateString('en-US', {
        ...options,
        timeZone: timeZone,
    });
    return formattedDateString;
};
const PrescribersProfile = (props) => {
    const { handleClose } = props;
    const { reset } = prescriptionActions;
    const dispatch = useDispatch();
    const {
        profile,
        engagements,
        isModalDataLoading,
        selectedNpiId,
        channels,
        vendors,
        fieldEngagement,
    } = useSelector((state) => state.prescription);
    const { company } = useSelector((state) => state.company);
    const [selectedNpi, setSelectedNpi] = useState(selectedNpiId);
    const hide = false; // need to remove
    const handleEngagementCount = (arr) => {
        const successfulEngagement = [
            'click',
            'open',
            'clicked',
            'pageview',
            'video',
            'view',
        ];

        let engagementCount = arr.reduce((acc, curr) => {
            const isExists = successfulEngagement.includes(
                curr.action?.toLowerCase(),
            );

            if (isExists) {
                return (acc += 1);
            }

            return acc;
        }, 0);
        if (fieldEngagement) {
            engagementCount = engagementCount + 1;
        }
        return engagementCount;
    };

    const handleHideDecile = () => {
        const companyIds = [
            33, 32, 18, 20, 34, 41, 40, 51, 53, 59, 150, 62, 58, 81, 72, 90, 92,
            16,
        ];
        return !companyIds.includes(company.id);
    };

    const handleHideTotalRX = () => {
        const companyIds = [
            18, 20, 34, 37, 41, 51, 53, 59, 140, 66, 64, 72, 90, 92, 16,
        ];
        return companyIds.includes(company.id);
    };

    const handleHideTotalRXValue = () => {
        const companyIds = [
            18, 20, 34, 37, 41, 40, 51, 53, 59, 140, 66, 64, 58, 81, 72, 90, 92,
            16,
        ];
        return companyIds.includes(company.id);
    };

    const handleHideUniquePatients = () => {
        const companyIds = [
            3, 16, 18, 20, 33, 37, 41, 40, 51, 53, 59, 140, 66, 64, 62, 58, 81,
            72, 90, 92,
        ];
        return companyIds.includes(company.id);
    };

    const handleHideTotalTrigger = () => {
        const companyIds = [18, 20, 34, 37];
        return companyIds.includes(company.id);
    };

    const handleHideTouchPoints = () => {
        const companyIds = [];
        return companyIds.includes(company.id);
    };

    const handleHideEngagements = () => {
        const companyIds = [];
        return companyIds.includes(company.id);
    };

    const handleHideFirstReferralAndLastRxDate = () => {
        const companyIds = [
            18, 20, 34, 37, 41, 51, 53, 59, 140, 66, 64, 72, 90, 92,
        ];
        return !companyIds.includes(company.id);
    };
    const handleUniquePatientsTitle = () => {
        const titleCompanies = [41, 51, 53, 59, 150, 72, 90, 92];
        const title = 'Patients Treated with BsAbs';
        return titleCompanies.includes(company.id) ? title : 'Unique Patients';
    };

    const handleGridSize = () => {
        let i = 0;
        if (!handleHideEngagements()) i++;
        if (!handleHideTotalRX()) i++;
        if (!handleHideTotalRXValue()) i++;
        if (!handleHideUniquePatients()) i++;
        if (!handleHideTotalTrigger()) i++;
        if (!handleHideTouchPoints()) i++;
        const xs = i <= 4 ? 6 : 4;
        return xs;
    };
    const handleHideSpecialty = () => {
        let bool = false;
        switch (company.id) {
            case 3: // Tepmetko
                bool = true;
                break;
            default:
                bool = false;
                break;
        }

        return bool;
    };

    const hideTriggerDate = () => {
        const companies = [66, 64, 161];
        return !companies.includes(company.id);
    };

    const triggerTypeTitle = () => {
        const title = {
            161: 'Target Audience Type',
            66: 'Target Audience Type',
            64: 'Target Audience Type',
            default:
                profile &&
                profile.triggered_type &&
                Array.isArray(profile.triggered_type) &&
                profile.triggered_type.length > 1
                    ? 'Trigger Types'
                    : 'Trigger Type',
        };
        return title[company.id] || title.default;
    };

    useEffect(() => {
        if (selectedNpiId) {
            setSelectedNpi(selectedNpiId);
            dispatch(reset());
            dispatch(
                getProfileData({
                    companyId: company.id,
                    data: { npi_ids: [selectedNpiId] },
                }),
            );
        }
    }, [selectedNpiId]);

    return (
        <Box className="custom-modal-inner-container-center background-#FFFFFF">
            {/* Modal Title */}
            <Grid
                container
                className="padding-tb-24-rl-16 sticky_modal_header border-1-gray"
            >
                <Grid item className="flex-row-space-between-center" xs={12}>
                    <Box>
                        <Typography className="text-lg-medium gray-900">
                            {handlePrescribersHeading(company.id)
                                ? 'Engager'
                                : 'Prescriber'}{' '}
                            Profile
                        </Typography>
                    </Box>
                    <Box className="icon" onClick={() => handleClose(null)}>
                        <CloseIcon color="#98A2B3" height="12" width="12" />
                    </Box>
                </Grid>
            </Grid>
            {/* Prescriber Profile and Details */}
            <Grid container className="padding-tb-24-rl-40">
                {/* Prescriber Profile */}
                <Grid item xs={6}>
                    <Box className="flex-row-align-items-center">
                        <Box className="pr-24px">
                            {isModalDataLoading ? (
                                <Skeleton
                                    height={80}
                                    variant="circular"
                                    width={80}
                                />
                            ) : (
                                <Avatar
                                    alt={`${profile?.provider?.first_name} ${profile?.provider?.last_name}`}
                                    className="prescriber-profile-avatar"
                                    src={`https://pfiq-v1-dev.s3.us-west-2.amazonaws.com/Rx_images/${selectedNpi}.jpg`}
                                />
                            )}
                        </Box>
                        <Box className="flex-column-start-center">
                            <Box>
                                <Typography className="display-xs-medium gray-900">
                                    {isModalDataLoading ? (
                                        <Skeleton width={150} />
                                    ) : profile?.provider?.first_name &&
                                      profile?.provider?.last_name ? (
                                        'Dr. ' +
                                        profile.provider.first_name +
                                        ' ' +
                                        profile.provider.last_name
                                    ) : (
                                        '-'
                                    )}
                                </Typography>
                            </Box>
                            <Box className="flex-row-align-items-center gap-4">
                                <Typography className="text-sm-regular gray-500">
                                    NPI ID:
                                </Typography>
                                <Typography className="text-sm-medium gray-700">
                                    {isModalDataLoading ? (
                                        <Skeleton width={100} />
                                    ) : (
                                        profile?.provider?.npi_id
                                    )}
                                </Typography>
                            </Box>
                            {!handleHideSpecialty() ? (
                                <Box className="flex-row-align-items-center gap-4">
                                    <Typography className="text-sm-regular gray-500">
                                        Specialty:
                                    </Typography>
                                    <Typography className="text-sm-medium gray-700">
                                        {isModalDataLoading ? (
                                            <Skeleton width={120} />
                                        ) : (
                                            profile?.provider?.specialty
                                        )}
                                    </Typography>
                                </Box>
                            ) : null}
                        </Box>
                    </Box>
                </Grid>

                {/* Prescriber Trigger Date and Types */}
                <Grid item xs={6}>
                    <Box className="flex-column gap-12 pl-24px border-left-gray-300">
                        {/* Trigger Date + Type Combined Logic */}
                        {hideTriggerDate() && (
                            <Box className="flex-column gap-2">
                                <Typography className="text-sm-medium gray-700">
                                    Triggered Date & Type:
                                </Typography>

                                <Typography className="text-sm-regular gray-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : Array.isArray(
                                          profile?.triggered_date_and_type_list,
                                      ) &&
                                      profile.triggered_date_and_type_list
                                          .length > 0 ? (
                                        Object.values(
                                            profile.triggered_date_and_type_list.reduce(
                                                (acc, item) => {
                                                    if (!acc[item.name]) {
                                                        acc[item.name] = {
                                                            name: item.name,
                                                            dates: [],
                                                        };
                                                    }
                                                    acc[item.name].dates.push(
                                                        item.date,
                                                    );
                                                    return acc;
                                                },
                                                {},
                                            ),
                                        )
                                            .map((group) => {
                                                const sortedDates = [
                                                    ...group.dates,
                                                ].sort(
                                                    (a, b) =>
                                                        new Date(b) -
                                                        new Date(a),
                                                );

                                                const dateString =
                                                    sortedDates.join(', ');
                                                return `${updateStringNPPA(group.name)}: ${dateString}`;
                                            })
                                            .join(' | ')
                                    ) : (
                                        '-'
                                    )}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>

            <Grid
                container
                className="prescriber-card-container"
                spacing={'8px'}
            >
                {/* Total Trigger */}
                {!handleHideTotalTrigger(company.id) ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-warning-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium warning-400">
                                    {profile?.total_trigger > 1
                                        ? 'Total Triggers'
                                        : 'Total Trigger'}
                                </Typography>
                                <Typography className="display-xs-semi-bold warning-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : (
                                        (profile?.total_trigger ?? '0')
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <img
                                    alt="Total Trigger"
                                    height={40}
                                    src={TotalTrigger}
                                    width={40}
                                />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}
                {/* Unique Patients */}
                {!handleHideUniquePatients() ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-purple-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium purple-400">
                                    {handleUniquePatientsTitle()}
                                </Typography>
                                <Typography className="display-xs-semi-bold purple-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : (
                                        (profile?.total_unique_patients ?? '0')
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <img
                                    alt="Unique Patients"
                                    height={40}
                                    src={UniquePatients}
                                    width={40}
                                />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}

                {/* Touch Points */}
                {!handleHideTouchPoints() ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-blue-light-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium blue-light-400">
                                    {profile?.total_points > 1
                                        ? 'Total Touch Points'
                                        : 'Total Touch Point'}
                                </Typography>
                                <Typography className="display-xs-semi-bold blue-light-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : fieldEngagement ? (
                                        profile?.total_points + 1
                                    ) : (
                                        (profile?.total_points ?? '0')
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <Check color="#0BA5EC" />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}

                {/* Engagement */}
                {!handleHideEngagements() ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-warning-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium warning-400">
                                    {handleEngagementCount(
                                        profile?.engagement_data || [],
                                    ) > 1
                                        ? 'Total Engagements'
                                        : 'Total Engagement'}
                                </Typography>
                                <Typography className="display-xs-semi-bold warning-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : (
                                        handleEngagementCount(
                                            profile?.engagement_data || [],
                                        )
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <Touch color="#FDB022" />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}
                {/* Total Rx */}
                {!handleHideTotalRX() ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-purple-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium purple-400">
                                    {company.id === 161
                                        ? 'Total Bottles'
                                        : 'Total Rx'}
                                </Typography>
                                <Typography className="display-xs-semi-bold purple-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : (
                                        (profile?.total_rx ?? '0')
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <img
                                    alt="Total Rx"
                                    height={40}
                                    src={TotalRx}
                                    width={40}
                                />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}
                {/* Total Rx Value */}
                {!handleHideTotalRXValue() ? (
                    <Grid item xs={handleGridSize()}>
                        <Box className="flex-row-space-between gap-8 padding-16px bg-blue-light-50 br-16px">
                            <Box className="flex-column">
                                <Typography className="text-sm-medium blue-light-400">
                                    {company.id === 161
                                        ? 'Total Bottles Value'
                                        : 'Total Rx Value'}
                                </Typography>
                                <Typography className="display-xs-semi-bold blue-light-500">
                                    {isModalDataLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : profile?.total_rx_value ? (
                                        `$${profile?.total_rx_value}`
                                    ) : (
                                        'O'
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <img
                                    alt="Touch Points"
                                    height={40}
                                    src={TouchPoints}
                                    width={40}
                                />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}
            </Grid>

            <Grid container className="card-container-spacing">
                <Grid item className="br-16px bg-gray-50" xs={12}>
                    <Grid
                        container
                        className="flex-row padding-16px"
                        spacing={'8px'}
                        xs={12}
                    >
                        {/* Lead Segment */}
                        <Grid item xs={6}>
                            <Box className="card-container">
                                <Box className="flex-column">
                                    <Typography className="text-sm-bold primary-color">
                                        Lead Segment
                                    </Typography>
                                    <Typography className="text-md-medium gray-900">
                                        {isModalDataLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width={100}
                                            />
                                        ) : profile?.provider?.segmentation ? (
                                            profile.provider.segmentation
                                        ) : (
                                            'UNASSIGNED'
                                        )}
                                    </Typography>
                                </Box>
                                {hide && (
                                    <Box className="flex-row gap-8 pt-8px">
                                        <Typography className="text-2xs-regular gray-500">
                                            Last update:
                                        </Typography>
                                        <Typography className="text-2xs-regular gray-900">
                                            2023-06-03
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* Decile */}
                        {handleHideDecile() ? (
                            <Grid item xs={6}>
                                <Box className="card-container">
                                    <Box className="flex-column">
                                        <Typography className="text-sm-bold primary-color">
                                            Decile
                                        </Typography>
                                        <Typography className="text-md-medium gray-900">
                                            {isModalDataLoading ? (
                                                <Skeleton
                                                    variant="text"
                                                    width={100}
                                                />
                                            ) : (
                                                (profile?.provider?.decile ===
                                                '-'
                                                    ? '0'
                                                    : profile?.provider
                                                          ?.decile) || '0'
                                            )}
                                        </Typography>
                                    </Box>
                                    {hide && (
                                        <Box className="flex-row gap-8 pt-8px">
                                            <Typography className="text-2xs-regular gray-500">
                                                Last update:
                                            </Typography>
                                            <Typography className="text-2xs-regular gray-900">
                                                2023-06-03
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        ) : null}

                        {/* Channel Affinity */}
                        <Grid item xs={6}>
                            <Box className="card-container">
                                <Box className="flex-column">
                                    <Typography className="text-sm-bold primary-color">
                                        Channel Affinity
                                    </Typography>
                                    <Typography className="text-md-medium gray-900">
                                        {isModalDataLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width={100}
                                            />
                                        ) : channels?.length > 0 ? (
                                            channels.join(', ')
                                        ) : (
                                            '-'
                                        )}
                                    </Typography>
                                </Box>
                                {hide && (
                                    <Box className="flex-row gap-8 pt-8px">
                                        <Typography className="text-2xs-regular gray-500">
                                            Last update:
                                        </Typography>
                                        <Typography className="text-2xs-regular gray-900">
                                            2023-06-03
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* Vendor Afinity */}
                        <Grid item xs={6}>
                            <Box className="card-container">
                                <Box className="flex-column">
                                    <Typography className="text-sm-bold primary-color">
                                        Vendor Affinity
                                    </Typography>
                                    <Typography className="text-md-medium gray-900">
                                        {isModalDataLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width={100}
                                            />
                                        ) : vendors?.length > 0 ? (
                                            vendors.join(', ')
                                        ) : (
                                            '-'
                                        )}
                                    </Typography>
                                </Box>
                                {hide && (
                                    <Box className="flex-row gap-8 pt-8px">
                                        <Typography className="text-2xs-regular gray-500">
                                            Last update:
                                        </Typography>
                                        <Typography className="text-2xs-regular gray-900">
                                            2023-06-03
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* First Touch */}
                        <Grid item xs={3}>
                            <Box className="card-container">
                                <Box className="flex-column">
                                    <Typography className="text-sm-bold primary-color">
                                        First Touch
                                    </Typography>
                                    <Typography className="text-md-medium gray-900">
                                        {isModalDataLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width={100}
                                            />
                                        ) : (
                                            formattedDate(profile?.first_touch)
                                        )}
                                    </Typography>
                                </Box>
                                {hide && (
                                    <Box className="flex-row gap-8 pt-8px">
                                        <Typography className="text-2xs-regular gray-500">
                                            Last update:
                                        </Typography>
                                        <Typography className="text-2xs-regular gray-900">
                                            2023-06-03
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* Last Touch */}
                        <Grid item xs={3}>
                            <Box className="card-container">
                                <Box className="flex-column">
                                    <Typography className="text-sm-bold primary-color">
                                        Last Touch
                                    </Typography>
                                    <Typography className="text-md-medium gray-900">
                                        {isModalDataLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width={100}
                                            />
                                        ) : (
                                            formattedDate(profile?.last_touch)
                                        )}
                                    </Typography>
                                </Box>
                                {hide && (
                                    <Box className="flex-row gap-8 pt-8px">
                                        <Typography className="text-2xs-regular gray-500">
                                            Last update:
                                        </Typography>
                                        <Typography className="text-2xs-regular gray-900">
                                            2023-06-03
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {handleHideFirstReferralAndLastRxDate() ? (
                            <>
                                {/* First Referral */}
                                <Grid item xs={3}>
                                    <Box className="card-container">
                                        <Box className="flex-column">
                                            <Typography className="text-sm-bold primary-color">
                                                First Referral
                                            </Typography>
                                            <Typography className="text-md-medium gray-900">
                                                {isModalDataLoading ? (
                                                    <Skeleton
                                                        variant="text"
                                                        width={100}
                                                    />
                                                ) : (
                                                    formattedDate(
                                                        profile?.first_rx_date,
                                                    )
                                                )}
                                            </Typography>
                                        </Box>
                                        {hide && (
                                            <Box className="flex-row gap-8 pt-8px">
                                                <Typography className="text-2xs-regular gray-500">
                                                    Last update:
                                                </Typography>
                                                <Typography className="text-2xs-regular gray-900">
                                                    2023-06-03
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>

                                {/* Last Rx Date */}
                                <Grid item xs={3}>
                                    <Box className="card-container">
                                        <Box className="flex-column">
                                            <Typography className="text-sm-bold primary-color">
                                                Last Rx Date
                                            </Typography>
                                            <Typography className="text-md-medium gray-900">
                                                {isModalDataLoading ? (
                                                    <Skeleton
                                                        variant="text"
                                                        width={100}
                                                    />
                                                ) : (
                                                    formattedDate(
                                                        profile?.last_rx_date,
                                                    )
                                                )}
                                            </Typography>
                                        </Box>
                                        {hide && (
                                            <Box className="flex-row gap-8 pt-8px">
                                                <Typography className="text-2xs-regular gray-500">
                                                    Last update:
                                                </Typography>
                                                <Typography className="text-2xs-regular gray-900">
                                                    2023-06-03
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            </>
                        ) : null}
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Box className="prescriber-engagement-table-container">
                    <EngagementTypeTable
                        engagements={engagements}
                        isModalDataLoading={isModalDataLoading}
                        npiId={selectedNpiId}
                    />
                </Box>
            </Grid>
        </Box>
    );
};

export default PrescribersProfile;
